module.exports = __webpack_public_path__ + "img/Kovacs-Szecsi_Henrieta - Founder.cc547c01.jpg";